import { render, staticRenderFns } from "./DialogNotaArmario.vue?vue&type=template&id=318ffae0"
import script from "./DialogNotaArmario.vue?vue&type=script&lang=js"
export * from "./DialogNotaArmario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports